'use client'
import { DetailPageHeader } from '@/components/header/detail-page-header'
import { FLOWS_PATH } from '@/lib/flow-templates/slug'
/** The app-shell header for a flow page: Flows › {Brand} flow. */
export function FlowHeaderInjector({ brandName }: { brandName: string }) {
  return (
    <DetailPageHeader
      parentLabel="Flows"
      parentHref={FLOWS_PATH}
      title={`${brandName} flow`}
    />
  )
}
